export const UserInlineTypes = {
  WITH_NAME: 0,
  IMAGE_ONLY: 1,
};
